import { View } from "@Engage.Data/modules/view/View";
export class ConversationViewQualifier {
    constructor() {
        this.key = "ConversationView";
    }
    process() {
        // Returns active conversation view count + 1 (current page load not yet incremented).
        // Different from MeterView which is the total meter-level count.
        return String(View.getTotalConversationViewCount() + 1);
    }
}
